var i = /* @__PURE__ */ ((a) => (a.Arizonia = "arizonia", a.Inter = "inter", a.Kanit = "kanit", a.Lato = "lato", a.Lora = "lora", a.Merriweather = "merriweather", a.Montserrat = "montserrat", a.NotoSans = "notosans", a.Nunito = "nunito", a.OpenSans = "opensans", a.PlayfairDisplay = "playfairdisplay", a.Poppins = "poppins", a.Roboto = "roboto", a.SourceSansPro = "sourcesanspro", a.Ubuntu = "ubuntu", a))(i || {});
export {
  i as StoreFontEnum
};
